import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/ProjectBox.css"; // Custom CSS file
import LayOut from "../../Component/components/LayOut";
import { FaDownload } from "react-icons/fa";

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch projects from the database
  useEffect(() => {
    const cachedProjects = localStorage.getItem("projects");
    if (cachedProjects) {
      setProjects(JSON.parse(cachedProjects));
    } else {
      const fetchProjects = async () => {
        try {
          const response = await fetch(
            `https://portfoliomern-mxue.onrender.com/api/v1/project/projects?page=${currentPage}`
          );
          const data = await response.json();
          if (data.success) {
            setProjects(data.projects);
            setTotalPages(data.totalPages);
            localStorage.setItem("projects", JSON.stringify(data.projects));
          } else {
            console.error("Failed to fetch projects");
          }
        } catch (error) {
          console.error("Error fetching projects:", error);
        }
      };

      fetchProjects();
    }
  }, [currentPage]); // Re-fetch projects when currentPage changes

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <LayOut title={"Projects"}>
      <div className="container mt-4">
        <div className="row">
          {projects.map((project) => (
            <div className="col-md-4 mb-4" key={project._id}>
              <div className="project-box p-3">
                <div className="project-image-container">
                  <img
                    src={
                      project.photo?.data
                        ? `data:${project.photo.contentType};base64,${btoa(
                            new Uint8Array(project.photo.data.data).reduce(
                              (data, byte) => data + String.fromCharCode(byte),
                              ""
                            )
                          )}`
                        : "https://via.placeholder.com/300"
                    }
                    alt={project.name}
                    className="img-fluid rounded"
                    loading="lazy" // Lazy loading
                  />
                  <div className="download-icon">
                    <FaDownload />
                  </div>
                </div>
                <h2 className="project-name mt-3">{project.name}</h2>
                <p className="project-description">{project.description}</p>
                <div className="d-flex justify-content-between mt-3">
                  <a
                    href={project.OutputUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-output"
                  >
                    View Output
                  </a>
                  <a
                    href={project.GitHubUrl} // GitHub URL from the database
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-learn-more"
                  >
                    Source Code
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </LayOut>
  );
};

export default Project;
